<template>
  <b-col>
  <div id="vimeoPlayer" class="vimeoPlayer embed-responsive embed-responsive-16by9 video"></div>
    </b-col>
</template>

<script>
import Player from '@vimeo/player'
import { getAPI } from '../store/axios-base'

export default {
  name: 'Player',
  props :['id','item'],
  data() {
     return {
        player: null,
         seconds:0,
         duration:0,
         video_playing: null,
     }
  },

  computed: {
      percentage: function() {
          return this.seconds / this.duration
      },
      video_id: function(){
          return this.item.video_id
      }
  },

  methods: {
  handleBlur(){
    console.log('blur')
  },
  beforeDestroy () {
	clearInterval(this.video_playing)
  },

  sendData(){
    getAPI.post('/api/v1/watching/',{
    record_id: this.id,
    time: this.seconds,
    percentage: this.percentage,
    length: this.duration
  },{headers: { Authorization: `Bearer ${this.$store.state.accessToken}` }}).then(function (response) {
    console.log(response);
  })
  .catch(function (error) {
    console.log(error);
  });

  },

  onPlay:function(data){
      this.video_playing = setInterval(() => {
       this.player.getCurrentTime().then((seconds) => {
          this.seconds = seconds;
           this.sendData();
           }).catch(function (error) {
    console.log(error);
  });

  }, 5000)
  },
  onPause:function(){
    clearInterval(this.video_playing)
  },
  onLoaded(){
    this.player.setCurrentTime(this.start_time).catch(function() {
        console.log('failed')
        });
    this.player.getDuration().then((seconds) => {
          this.duration = seconds;
           }).catch(function (error) {
          console.log(error);
  });


  },

  },

  watch:{
      video_id(newvar,oldvar){
          this.player = new Player("vimeoPlayer", {
          id: this.item.video_id,
          width: 800
      });
      this.start_time = this.item.start_time
      this.player.on('play', (data) => this.onPlay(data))
      this.player.on('pause', (data) => this.onPause(data))
      this.player.on('loaded', (data) => this.onLoaded(data))
      }
  },


  }

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/video_plus.vue